const toNumber = (value) => {
  const number = Number(value);
  return Number.isFinite(number) ? number : 0;
};

const sum = (items, selector) =>
  (Array.isArray(items) ? items : []).reduce(
    (total, item) => total + toNumber(selector(item || {})),
    0
  );

export const hasPositiveAmount = (value) => toNumber(value) > 0;

export const getQuickBillPrintSummary = (order = {}) => {
  const foodItems = Array.isArray(order.foodItem) ? order.foodItem : [];
  const wineItems = Array.isArray(order.wineItem) ? order.wineItem : [];
  const foodGross = sum(foodItems, (item) => item.price);
  const wineGross = sum(wineItems, (item) => item.price);
  const billCgst = toNumber(order.cgst);
  const billSgst = toNumber(order.sgst);
  const itemCgst = sum(foodItems, (item) => item.cgstAmount ?? item.cgst);
  const itemSgst = sum(foodItems, (item) => item.sgstAmount ?? item.sgst);
  const cgst = billCgst > 0 ? billCgst : itemCgst;
  const sgst = billSgst > 0 ? billSgst : itemSgst;
  const percentageDiscountRate = toNumber(order.discountPercentage);
  const foodDiscountRate = toNumber(order.foodDiscount);
  const wineDiscountRate = toNumber(order.wineDiscount);
  const happyHourDiscountRate = toNumber(
    order.happyHourDiscountPercentage ?? order.happyHourDiscount
  );

  return {
    cgst,
    sgst,
    gstTotal: cgst + sgst,
    flatDiscount: toNumber(order.discount),
    percentageDiscountRate,
    percentageDiscountAmount:
      ((foodGross + wineGross) * percentageDiscountRate) / 100,
    foodDiscountRate,
    foodDiscountAmount: (foodGross * foodDiscountRate) / 100,
    wineDiscountRate,
    wineDiscountAmount: (wineGross * wineDiscountRate) / 100,
    happyHourDiscountRate,
    happyHourDiscountAmount:
      ((foodGross + wineGross) * happyHourDiscountRate) / 100,
    totalBilling: toNumber(order.totalBilling),
  };
};
